import $ from 'jquery';
import actions from '@wc-stripe/actions';
import {isEqual} from "lodash";

actions.addAction('before_form_submit', controller => {
    if (controller.context.isExpressCheckout()) {
        if (controller.needsShipping()) {
            if ($('[name="bill_to_different_address"]').length > 0) {
                /**
                 * If the shipping address differs from the billing address, make sure
                 * "different_from_shipping" is selected
                 * @type {*|string|jQuery}
                 */
                const billingAddress = controller.fields.getCartFullAddress('billing');
                const shippingAddress = controller.fields.getCartFullAddress('shipping');

                // if the billing and shipping address do not match
                // make sure the "different_from_shipping" option is checked.
                if (!isEqual(billingAddress, shippingAddress)) {
                    const value = $('[name="bill_to_different_address"]:checked').val();
                    if (value !== 'different_from_shipping') {
                        $('[name="bill_to_different_address"][value="different_from_shipping"]').prop('checked', true);
                    }
                }
            }
        }
        //redirect the customer to the #cfw-payment-method step.
        window.location.hash = '#cfw-payment-method';
    }
});